import React, { useState } from 'react';
import { ComponentProps } from 'lib/component-props';
import RichTextA11yWrapper from 'helpers/RichTextA11yWrapper/RichTextA11yWrapper';
import SVG from 'helpers/SVG/SVG';

interface ItemType {
  fields: {
    CopyText: { value: string };
    Title: { value: string };
  };
}

interface LayoutProps {
  fields: {
    items: Array<ItemType>;
  };
}

type AccordionItemProps = {
  item: ItemType;
  isOpen: boolean;
  onClick: () => void;
};

export type AccordionCollectionProps = ComponentProps & LayoutProps;

const AccordionItem = ({ item, isOpen, onClick }: AccordionItemProps): JSX.Element => {
  return (
    <div className="w-full">
      <button
        tabIndex={0}
        onClick={onClick}
        role="button"
        className={`btn-accordion ${isOpen ? 'btn-accordion--open' : ''}`}
      >
        <RichTextA11yWrapper field={item?.fields?.Title} />
        {
          <SVG
            className={`transition-all transform ${isOpen ? 'rotate-180' : ''}`}
            svg="icon-chevron-down"
          ></SVG>
        }
      </button>
      <div
        className={`accordion-collection mt-3 mx-5 text-light-fill-primary-variant ${
          isOpen ? 'showText' : 'hidden'
        }`}
      >
        <RichTextA11yWrapper className={`px-5 rtaw p3`} field={item?.fields?.CopyText} />
      </div>
    </div>
  );
};

const AccordionCollection = (props: AccordionCollectionProps): JSX.Element => {
  const [activeIndex, setActiveIndex] = useState<number | null>(null);

  const handleItemClick = (index: number) => {
    setActiveIndex((prevIndex) => (prevIndex === index ? null : index));
  };

  return (
    <div className={`component`}>
      <div className="flex">
        <div className="flex flex-col gap-4 mx-4 w-full">
          {props.fields.items.map((item: ItemType, i) => {
            return (
              <div key={i}>
                <AccordionItem
                  item={item}
                  isOpen={activeIndex === i}
                  onClick={() => handleItemClick(i)}
                />{' '}
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default AccordionCollection;
